import type { ReactNode } from "react";

export default function Field({ children }: { children: ReactNode }): ReactNode {
    return <section className="flex flex-col gap-2">{children}</section>;
}
